import { CustomerSpecificOption } from "./customer-specific-option";

export class SavingAgreementInterestPayment {
  interestAmount: number;
  taxAmount: number;
  totalAmount: number;
  calculatedInterestAmount: number;
  calculatedTaxAmount: number;
  calculatedTotalAmount: number;
  currency: string;
  description: string;
  customerSpecificOptions: CustomerSpecificOption[];
  savingAgreementPaymentOps: any[];
  scheduleDates: string[];
  documentNumber: string;
  date: string;
  agreementNumber: string;
  branchId: string;
}